import React from 'react';

import { Container, Content, Form } from './style';

import { useUfController } from '../../../../hooks/controllers/uf-controller';
import { FormContext } from '../../hook/form-context';
import SelectEmpretecWeb from './select-empretec-web';
import { useDisplay } from '../../hook/useDisplay';
import SelectEmpretecMobile from './select-empretec-mobile';
import { BaSeButton } from '@base/react';

function Subscription() {
  const { getUfs } = useUfController();
  const { isLargeDisplay } = useDisplay();

  const {
    setListUf,
    showButtonStartInterview,
    handleCreateInterview,
    empretecId,
  } = React.useContext(FormContext);

  const mapNameButton = {
    1: 'Fazer minha entrevista',
    2: 'Iniciar minha autoavaliação',
    3: 'Fazer minha entrevista',
    4: 'Desejo participar',
  };

  React.useEffect(() => {
    getUfs()
      .then((response) => {
        response.unshift({
          id: 0,
          label: 'Selecione',
          sigla: 'Selecione',
        });
        setListUf(response);
      })
      .catch(() => setListUf([]));
  }, [getUfs, setListUf]);

  return (
    <Container id="7">
      <Content>
        <Form>
          {isLargeDisplay() ? <SelectEmpretecWeb /> : <SelectEmpretecMobile />}

          {/* <ListClasses
            classes={classes}
            handlePageChange={handlePageChange}
            pageIndex={pageIndex}
            handleSelectClass={handleSelectClass}
            selectedIdClass={selectedIdClass}
            selectedUfOption={selectedUfOption}
            totalItems={totalItems}
            totalPages={totalPages}
          /> */}

          {/* {selectedIdClass && (
            <FormPersonalData
              handleChangePersonalData={handleChangePersonalData}
              personalData={personalData}
            />
          )} */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 12,
            }}
          >
            {isLargeDisplay() && showButtonStartInterview && (
              <BaSeButton
                borderRadius="max"
                buttonType="submit"
                overrideColors={{
                  backgroundColor: '#fff',
                  foreground: '#0000C9',
                }}
                leftIcon=""
                onClick={() => handleCreateInterview()}
                loadingText="Carregando…"
                size="big"
                type="primary"
                value={mapNameButton[empretecId]}
              />
            )}
          </div>
        </Form>
      </Content>
    </Container>
  );
}

export default Subscription;
